var render = function render(_c,_vm){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","width":"36","height":"36"}},[_c('path',{attrs:{"fill":_vm.props.fill || 'currentColor',"d":"M2 15V5c0-1.1.9-2 2-2h16a2 2 0 0 1 2 2v15a1 1 0 0 1-1.7.7L16.58 17H4a2 2 0 0 1-2-2zM20 5H4v10h13a1 1 0 0 1 .7.3l2.3 2.29V5z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }